import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

export type ConfirmDialogType = 'primary' | 'success' | 'warning' | 'danger' | 'info';

@Component({
  selector: 'app-confirm-dialog',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './confirm-dialog.component.html',
})
export class ConfirmDialogComponent {
  @Input() isOpen = false;
  @Input() title = '確認操作';
  @Input() message = '';
  @Input() confirmText = '確認';
  @Input() cancelText = '取消';
  @Input() type: ConfirmDialogType = 'primary';
  @Input() fontSize = 18;
  @Input() closeOnBackdropClick = true;
  @Input() showCloseButton = true;
  @Input() confirmDisabled = false;
  @Input() cancelDisabled = false;

  @Output() confirmAction = new EventEmitter<void>();
  @Output() cancelAction = new EventEmitter<void>();

  onBackdropClick(): void {
    if (this.closeOnBackdropClick && !this.cancelDisabled) {
      this.onCancel();
    }
  }

  onCancel(): void {
    if (this.cancelDisabled) return;
    this.cancelAction.emit();
  }

  onConfirm(): void {
    if (this.confirmDisabled) return;
    this.confirmAction.emit();
  }

  getIconWrapClass(): string {
    switch (this.type) {
      case 'success':
        return 'bg-app-supply-soft text-app-supply-dark';
      case 'warning':
        return 'bg-app-accent-soft text-app-accent-dark';
      case 'danger':
        return 'bg-app-danger-soft text-app-danger-text';
      case 'info':
        return 'bg-app-brand-soft text-app-brand-dark';
      default:
        return 'bg-app-brand-soft text-app-brand-dark';
    }
  }

  getConfirmButtonClass(): string {
    switch (this.type) {
      case 'success':
        return 'bg-app-supply focus:ring-app-supply';
      case 'warning':
        return 'bg-app-accent focus:ring-app-accent';
      case 'danger':
        return 'bg-app-danger focus:ring-app-danger';
      case 'info':
        return 'bg-app-brand focus:ring-app-brand';
      default:
        return 'bg-app-brand focus:ring-app-brand';
    }
  }
}
